module.exports = __webpack_public_path__ + "static/media/04_Timeline_district_2.09573d63.webp";